export default __webpack_public_path__ + "static/media/circle-down-arrow.0bd97173.svg";